import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import Header from '../../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../../GardenPopup/DeletePopup'
import SewerageWorkNamePopup from './SewerageWorkNamePopup'
import { useAuthState } from '../../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { SeverageWorkNameDeleteAPI, SeverageWorkNameTableDataAPI } from '../../../../../../../Redux/SeverageDashboardSlice/SeverageWorkNameMasterSlice'
import { SeverageWorkTypeDataDDL } from '../../../../../../../Components/CommonDDL/SeverageWorkTypeDataDDL'
import { Loading } from '../../../../../../../Helper/Loading'
import { Pegination } from '../../../../../../../Components/Pegination/Pegination'
import { SeverageWorkPeriodDataDDL } from '../../../../../../../Components/CommonDDL/SeverageWorkPeriodDataDDL'


export default function SewerageWorkNameData() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    // console.log(ApiFlag)

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [IsSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [LocationMasterPopupShow, setLocationMasterPopupShow] = useState(false)
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [SewerageMasterPopupShow, setSewerageMasterPopupShow] = useState()
    const [WorkName, setWorkName] = useState('')

    const [SeverageWorkType, setSeverageWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WorkPeriod, setWorkPeriod] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setSewerageMasterPopupShow(true)
    }

    const handleEditOnClick = (item) => {
        setapiFlag('Update')
        setrowData(item)
        setSewerageMasterPopupShow(true)
    }
    const handleOnCloseClick = () => {
        setSewerageMasterPopupShow(false)
        setIsClear(!IsClear)
        setapiFlag('')
    }

    const handleSearch = () => {
        setIsSearch(!IsSearch)
        setCurrentPage(0)
    }

    const handleClear = () => {
        setCurrentPage(0)
        setIsClear(!IsClear)
        setWorkName('')
        setSeverageWorkType({
            ...SeverageWorkType,
            ID: 0,
            Label: 'Select...',
        })
        setWorkPeriod({
            ...WorkPeriod,
            ID: 0,
            Label: 'Select...',
        })

        // console.log("call")
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }

    }

    const handleShowImage = (img) => {
        setLocationMasterPopupShow(true)
        setImagePopUpData(img)
    }

    useEffect(() => {
        const data = {
            // FinancialYearID: YearValue,
            M_SW_WorkNameID: 0,
            M_SW_WorkTypeID: SeverageWorkType.ID,
            M_SW_WorkPeriodID: WorkPeriod.ID,
            WorkName: WorkName,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
        }
        if (apiFlag != 'Update') {
            dispatch(SeverageWorkNameTableDataAPI({ data }))
        }
    }, [IsPost, To, IsSearch, IsClear, SeverageWorkType.ID, WorkPeriod.ID])

    const { tableData, isLoading } = useSelector(state => state.SeverageWorkNameTableData)

    const handleDeleteApi = (item) => {

        const data = {
            M_SW_WorkNameID: item.m_sW_WorkNameID,
            M_UserID: UserID,
            token: token,
            // Flag: 'Delete',
            handleIsPost: handleIsPost
        }
        dispatch(SeverageWorkNameDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.SeverageWorkTypeDeleteData)

    useEffect(() => {
        setCurrentPage(0)
        setFrom(1)
        setTo(10)
        // handleSearch()
    }, [SeverageWorkType.ID, WorkPeriod.ID])

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Sewerage Maintainance"
                    DashboardName={DashboardName} 
                    setYearValue={setYearValue}
                    MLable={MLable}
                    HMonth={HMonth}
                    YLable={YLable}
                    HYear={HYear}
                    HWard={HWard}
                    WLable={WLable}
                    flag='Screen'
                />
                <div className="wrapper">
                    <Sidebar ProjectTypeId={ProjectTypeId} />
                    <div className="content">
                        <div className="page-header ">
                            <div className="page-block">
                                <div className="row align-items-center">
                                    <div className="col-md-12">
                                        <div className="page-header-title">
                                            {/* <h5 className="ps-2 data_mob"> */}

                                            {/* <span className="float-end fs-6">
                                            <Select
                                                // isClearable
                                                // isRtl={isRtl}
                                                isSearchable
                                                maxMenuHeight={150}
                                                value={{ value: SelectWard.ID, label: SelectWard.Label }}
                                                onChange={(e) => {
                                                    e ?
                                                        setSelectWard({ ...SelectWard, ID: e.value, Label: e.label })
                                                        :
                                                        setSelectWard({ ...SelectWard, ID: 0, Label: "Select..." })

                                                }}
                                                options={SelectWard.DDL}
                                            />
                                            </span> */}
                                            {/* </h5> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='data_mob'>
                            <div className="row m-1 py-1 master_border">
                                <div className='col-6'>
                                    <h5 className="ps-1 py-1">Work Name Master</h5>
                                </div>
                                <div className=''>
                                    <div className="float-end butt">
                                        {/* <i class="fa-solid fa-plus add_btn" style={{ color: "#010813", fontSize: '17px' }}><span className="ml-2">Add</span></i> */}
                                        <button type="button" className="btn btn-primary float-end ml-1">Export</button>
                                        {/* <SewerageWorkNamePopup
                                        open={SewerageMasterPopupShow}
                                        handleIsPost={handleIsPost}
                                    /> */}
                                        <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                            style={{ color: "white" }}
                                            onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>
                                <div>
                                    <div className="row m-0 ">
                                        <div className="col-12 py-1 rounded rounded-2 shadow"
                                            style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                            <div className="col-12">

                                                <div className="row rounded2">

                                                    {/* <div className="col-12 col-md-6 col-lg-4">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>Work Name :</b></label>
                                                    <Select
                                                        // isClearable
                                                        // isRtl={isRtl}

                                                        isSearchable
                                                        maxMenuHeight={150}
                                                        value={{ value: WorkName.ID, label: WorkName.Label }}
                                                        onChange={(e) => {
                                                            e ?
                                                                setWorkName({ ...WorkName, ID: e.value, Label: e.label })
                                                                :
                                                                setWorkName({ ...WorkName, ID: 0, Label: "Select..." })

                                                        }}
                                                        options={WorkName.DDL}
                                                    />

                                                </div> */}
                                                    <div className="col-12 col-lg-3 col-md-5">
                                                        <SeverageWorkTypeDataDDL
                                                            SeverageWorkType={SeverageWorkType}
                                                            setSeverageWorkType={setSeverageWorkType}

                                                        />

                                                    </div>

                                                    <div className="col-12 col-lg-3 col-md-5">
                                                        <SeverageWorkPeriodDataDDL
                                                            WorkPeriod={WorkPeriod}
                                                            setWorkPeriod={setWorkPeriod}

                                                        />

                                                    </div>


                                                    <div className="col-12 col-lg-3 col-md-5">
                                                        <div className="form-group">
                                                            <label className="d-block" htmlFor="NameofDepartment"><b>Work Name :</b></label>
                                                            <input type="text"
                                                                className="form-control"
                                                                id="WorkName"
                                                                value={WorkName}
                                                                onChange={(e) => setWorkName(e.target.value)}
                                                            />
                                                        </div>

                                                    </div>
                                                    <div className="col-12 col-lg-3 mt-lg-4" >
                                                        <button type="button" className="btn-search btn btn btn-secondary mr-1"
                                                            onClick={() => handleSearch()} >
                                                            Search
                                                        </button>
                                                        <button type="button"
                                                            className="btn-clear btn btn-primary"
                                                            onClick={handleClear}>Clear</button>
                                                    </div>
                                                </div>
                                                <div className="row mob_table  table-responsive pt-2">
                                                    <table id="totalordergenerated"
                                                        cellPadding="0"
                                                        cellSpacing="0"
                                                        border="0"
                                                        className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th className="sr_no_col">Sr No.</th>
                                                                <th>Work Type</th>
                                                                <th>Work Period</th>
                                                                <th>Work Name</th>
                                                                <th>Bench Mark (Days)</th>
                                                                <th>Penalty Description</th>
                                                                <th>Penalty Amount(Rs)</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                                    <tr style={{ width: '100%' }}>
                                                                        <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                        <td>{item.workType ? item.workType : '-'}</td>
                                                                        <td>{item.m_sW_WorkPeriod ? item.m_sW_WorkPeriod : '-'}</td>
                                                                        <td>{item.workName ? item.workName : '-'}</td>
                                                                        <td>{item.benchMarks ? item.benchMarks : '-'}</td>
                                                                        <td>{item.penaltyDescription ? item.penaltyDescription : '-'}</td>
                                                                        <td>{item.penaltyAmount ? item.penaltyAmount.toFixed(2) : '-'}</td>
                                                                        <td style={{ textAlign: "center", width: '7%' }}>
                                                                           
                                                                                {/* <SewerageWorkNamePopup
                                                                                    open={SewerageMasterPopupShow}
                                                                                    handleIsPost={handleIsPost}
                                                                                    item={item}
                                                                                    Flag='Update'
                                                                                /> */}
                                                                                <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                    style={{ cursor: 'pointer' }}
                                                                                    onClick={() => handleEditOnClick(item)}
                                                                                >
                                                                                </i>
                                                                            <span>
                                                                                <DeletePopup
                                                                                    open={DeletePopupShow}
                                                                                    handleDeleteApi={handleDeleteApi}
                                                                                    item={item}
                                                                                />
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                )) :
                                                                    <>No data found</>
                                                            }

                                                        </tbody>
                                                    </table>
                                                </div>
                                                {tableData && tableData.table && tableData.table.length > 0 &&
                                                    <Pegination
                                                        PerPageCount={PerPageCount}
                                                        TotalCount={tableData.table[0].totalCount}
                                                        setFrom={setFrom}
                                                        setTo={setTo}
                                                        setrowNo={setrowNo}
                                                        CurrentPage={CurrentPage}
                                                        setCurrentPage={setCurrentPage}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        SewerageMasterPopupShow ?
                            <SewerageWorkNamePopup
                                open={SewerageMasterPopupShow}
                                popupHeading="Work Name Data"
                                handleIsPost={handleIsPost}
                                handleOnCloseClick={handleOnCloseClick}
                                Flag={apiFlag}
                                rowData={rowData}
                            />
                            : <></>
                    }
                </div >
            </div >
        </>
    )
}